"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { ga4CtaClick } from "@/lib/analytics/ga4-ecommerce";

type StepIconProps = {
	className?: string;
};

function OrderStepIcon({ className }: StepIconProps) {
	return (
		<svg className={className} viewBox="0 0 380.75 380.53" aria-hidden>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M189.01.06c17.41-1.02,36.52,12.07,39.73,29.69.98,5.41-.55,10.82,1.39,15.61,2.62,1.83,25.9-.6,31.54.46,2.48.47,4.02,2.82,5.08,4.92l15.51,143.54c.41,4.33-.71,8.32-5.01,10.07l-168.6.5c-11.82-.21-8.11-13.71-7.44-21.54,3.78-44.22,10.29-88.36,14.44-132.56,1.06-2.1,2.6-4.45,5.08-4.92,5.64-1.06,28.92,1.36,31.54-.46,1.94-4.79.4-10.2,1.39-15.61C156.56,13.74,173.15.99,189.01.06ZM169.19,45.79h44c3.78-38.49-47.78-38.48-44,0ZM122.19,142.79c-.59,5.66-1.45,11.36-2,17-.9,9.25-1.31,18.72-2,28h146c-.69-9.28-1.1-18.75-2-28-.55-5.64-1.41-11.34-2-17-2.81-26.99-6.23-54-9-81h-22c3.9,20.28-19.65,20.35-16,0h-44c3.65,20.35-19.9,20.28-16,0h-22c-2.77,27-6.19,54.01-9,81Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M260.19,142.79c.59,5.66,1.45,11.36,2,17H120.19c.55-5.64,1.41-11.34,2-17h138Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M80.19,250.79c25.27-17.37,57.29-21.42,85.38-7.88,5.5,2.65,19.1,13.93,22.33,14.67,25.3,5.77,75.49-13.67,86.01,20.99,1.14,3.76,1.18,7.43,1.79,11.23,19.75-10.84,38.26-27.54,57.82-38.18,33.68-18.31,62.53,19.42,38.16,47.16-27.68,17.21-54.62,41.26-82.57,57.43-9.46,5.48-18.48,7.78-29.38,8.62l-179.54-.04c-3.11-5.06-3.07-11.92,0-17l.69-2,185.15-.43c9.03-1.63,17.76-7.22,25.37-12.39,21.53-15.98,43.39-31.46,65.59-46.43,12.95-9.36-.77-26.16-10.27-20.7-18.18,10.44-35.14,22.51-52.06,34.87-20.01,16.48-34.19,20.41-58.29,21.41-17.4.72-34.82.97-52.24.64-6.93-.13-14-.37-20.82-1.21-13.96-1.73-16.29-15.01-3.73-20.56l84.04-.16c16.59-1.08,18.05-22.09,1.49-24.9-21.24-.23-42.51-.39-63.82-.5-30.53-26.26-64.47-28.98-97.64-5.35l-3.46-.3c-3.11-5.53-3.16-13.49,0-19Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M80.19,250.79c-.16,6.3-.05,12.8,0,19,3.4,25.66,3.57,52.35,0,78-.09,5.71-.17,11.28,0,17,.23,7.85-.24,13.91-9.48,15.02-18.68,2.25-41.79-1.67-60.96-.09-5.41-1-8.53-4.97-8.62-10.38,2.88-42.31-3.66-89.34,0-131.09.28-3.17,1.19-8.29,4.28-9.72,22.8-1.56,46.09-.55,69.05-.52,7.61,1.7,5.87,16.61,5.71,22.79ZM63.19,243.79H18.19v119h45v-119Z"
			/>
		</svg>
	);
}

function CustomizeStepIcon({ className }: StepIconProps) {
	return (
		<svg className={className} viewBox="0 0 381.41 378.04" aria-hidden>
			<path
				className="fill-[#3fdfcf]"
				d="M73.37,289.79c1.13.21,9.59,4.61,10.94,5.56,21.73,15.38,14.96,51.47-10.94,57.44-2.72,4.36-14.33,4.42-17,0-25.26-6.22-32.3-41.06-11.33-56.83,1.85-1.39,9.52-5.84,11.33-6.17l.85-2.12c2.85-.76,15.42-1.01,16.15,2.12ZM62.12,306.03c-17.24,2.72-17.42,30.31,2.11,31.19,22.79,1.02,20.97-34.83-2.11-31.19Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M73.37,289.79c-2.4-.45-14.6-.45-17,0,1.53-14.57-2.09-33.4.06-47.44,1.54-10.02,14.52-11.03,16.88-1.01l.06,48.44Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M73.37,352.79c-.94,7.68,3.99,25.28-8.51,25.11s-7.68-17.46-8.49-25.11c5.69,1.4,11.31,1.31,17,0Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M7.08,0l369.27.32c3.31,2.42,5.1,5.77,5.06,9.94v188.08c-.03,4.12-1.56,7.76-5.3,9.7-122.95,1.27-246.53,1.27-369.48,0-3.73-1.94-5.26-5.58-5.3-9.7,3.28-61.08-4.23-126.51,0-187.08C1.68,6.24,2.35,2.67,7.08,0ZM151.37,88.79c14.49,11.37,25.77,27.82,40.36,38.93l42.14-41.93c2.57-2.33,6.11-2.68,9.25-1.24l106.7,106.29c3.76,2.16,10.19.39,14.55.95V15.79H18.37v176c4.37-.55,10.79,1.21,14.55-.95,15.45-15.04,30.17-30.87,45.45-46.05,4.67-4.65,9.33-9.36,14-14,12.99-12.91,28.61-30.59,42-42,7.75-6.61,9.68-5.75,17,0ZM57.87,191.79h171l-86-87.98-87.02,86.97-.48,2.01c1.2.42,2.11-.95,2.49-1ZM254.87,191.79h70c.26,0,1.34,1.42,2.49,1l-.48-2.01-87.02-86.97-36.48,36.48,51.48,51.5Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M151.37,88.79c-7.32-5.75-9.25-6.61-17,0-4.14-24.25-31.04-37.59-53.04-26.54-31.42,15.79-24.11,64.54,11.04,68.54-4.67,4.64-9.33,9.35-14,14-37.46-14.65-45.89-66.03-13.92-91.42,33.4-26.51,81.24-5.79,86.92,35.42Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M326.37,258.79c.42.09,6.79,3.26,7.71,3.79,24.83,14.49,19.78,53.59-8.71,59.21-1.63,4.24-14.43,4.33-16,0-31.39-6.82-32.25-54.87,0-62l.63-2.17c3.34-1.15,15.16-2.7,16.37,1.17ZM315.13,275.01c-18.97,2.71-15.87,33.14,3.62,31.75,21.13-1.51,18.36-34.88-3.62-31.75Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M325.37,321.79c1.14,1.67.97,3.55,1.04,5.45.4,11.53,1.4,32.25-.11,42.98-1.4,9.92-15.32,10.91-16.84-.02-2.05-14.67,1.33-33.3-.09-48.41,6.47,1.41,9.54,1.28,16,0Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M326.37,258.79c-4.15-.89-12.76.06-17,1,.79-7.76-3.79-25.84,8.52-25.52,11.56.31,8.02,16.95,8.48,24.52Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M157.37,259.79c32.1,7.12,32.02,55.1,0,62-1.62,4.32-14.39,4.34-16,0-22.3-4.96-32-32.21-17.98-50.48,3.48-4.53,12.37-11.57,17.98-12.52,1.34-4,14.92-2.9,16,1ZM147.13,275.01c-23.43,3.44-13.49,39.96,8.93,29.97,16.17-7.21,8.67-32.55-8.93-29.97Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M157.37,321.79l-.06,49.44c-1.33,8.48-13.21,8.81-15.92,1.03l-.03-50.47c6.34,1.41,9.71,1.36,16,0Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M157.37,259.79c-4.46-.99-11.48-1.77-16-1,1.05-7.41-4.21-25.19,8.13-24.48s6.94,17.64,7.87,25.48Z"
			/>
			<path
				className="fill-[#3fdfcf]"
				d="M241.37,289.79c30.09,4.55,34.07,55.54,0,63-1.7,4.32-14.3,4.32-16,0-33.9-7.41-29.48-57.98,0-63,.02-.77.12-1.93.71-2.1,2.58-.76,14.75-1.06,15.29,2.1ZM230.1,306.03c-16.51,2.97-16.24,28.97.77,30.76,26.04,2.75,22.94-35.02-.77-30.76Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M241.37,289.79c-2.88-.44-13.2-.48-16,0l.06-48.44c1.42-8.96,14.58-9.32,15.88-.99l.06,49.44Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M241.37,352.79c-1.17,7.7,4.28,24.57-7.52,25.07-12.59.54-7.52-17.43-8.48-25.07,6.24,1.36,9.74,1.37,16,0Z"
			/>
		</svg>
	);
}

function LaunchStepIcon({ className }: StepIconProps) {
	return (
		<svg className={className} viewBox="0 0 403.09 402.83" aria-hidden>
			<path
				className="fill-[#3fdfcf]"
				d="M76.75,281.08c.22.22,1.93.35,3.03,1.43,5.43,5.33,12.11,11.18,15.97,17.57l-2.42.96c-8.05-3.93-17.24-1.81-23.57,4.29l-34.05,62.42c15.88-9.1,32.19-17.48,48.94-25.14,13.84-7.53,25.2-16.32,17.29-33.02l.81-2.52c6.75,4.21,12.88,11.21,18.57,16.97,1.08,1.09,1.22,2.81,1.43,3.03-3.56,11.98-9.15,19.32-19.69,25.81-28.53,17.56-61.62,31.17-90.58,48.41-7.56,3.2-14.14-3.4-10.94-10.94,17.78-28.62,31.54-63.29,49.8-91.19,5.9-9.02,14.7-16.05,25.42-18.08Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M76.75,281.08c-5.27-5.1-12.12-10.72-10.94-18.43,1.45-9.54,15.51-26.76,18.49-36.52.31-1.02.64-1.95.46-3.04L5.95,206.38c-5.94-1.81-7.88-8.65-3.74-13.34l65.04-64.96c4.88-4.18,11.55-1.11,16.96-.96,19.86.57,39.7,1.52,59.59,2.41C200.87,54.75,296.29,3.09,391.23.02c13.64-.44,12.05,8.91,11.51,19.55-.76,14.86-4.22,32.91-7.48,47.52-16.92,75.82-59.63,146.43-122.27,192.61l1.8,24.84c.02,12.09.69,23.94.97,36.03.11,4.73,3.09,10.61-1.01,15.01l-64.96,65.04c-4.69,4.14-11.53,2.21-13.34-3.74l-16.7-78.8c-1.41-1.44-31.31,17.38-35.32,19.17-9.53,4.27-15.23-3.6-21.68-10.17l-2.18-.23c-5.92-6.51-11.86-13.1-17.82-19.77-3.02.57-7.08-4.01-7-7-6.33-5.53-12.53-11.12-18.61-16.77l-.39-2.23ZM385.74,17.08c-33.53,3.26-67.17,9.75-97.97,23.5l74.48,74.48c13.42-30.81,21.16-64.41,23.49-97.98ZM269.49,48.22c-2.83.4-15.56,8.06-19.05,10.06-40.84,23.42-73.65,53.86-100.92,92.08-14.76,20.69-27.6,42.77-40.39,64.72l.52,2.52,32.45,31.41,41.71-41.36c8.3-6.68,18.2,2.14,12.39,11.39l-42.44,42.54,32.62,32.4c29.04-17.47,59.37-34.81,86.25-55.5s50.27-48.44,67.91-78.09c3.03-5.09,12.93-21.6,13.81-26.29.26-1.39.68-2.39-.54-3.55-11.03-7.77-78.5-83.16-84.33-82.33ZM131.75,146.09l-6.46-1.05-49.84-1.75-48.21,47.79-1.49,3,68.85,13.86,37.14-61.85ZM100.25,232.1l-16.34,31.34c2.77,2.74,20.45,21.88,22.2,21.57l23.62-23.43-29.48-29.48ZM208.75,377.07l3-1.49,47.79-48.21-.75-28.84-2.05-28.46-62.04,38.71,14.06,68.29ZM141.38,274.15l-23.62,23.43,22.62,22.34c3.84-1.85,30.35-15.59,30.34-17.34l-29.35-28.43Z"
			/>
			<path
				className="fill-core-midnight dark:fill-core-primary"
				d="M252.57,102.35c59.9-2.69,64.21,87.13,8.67,92.72-66.71,6.71-70.42-89.95-8.67-92.72ZM250.5,119.34c-41.99,5.5-28.18,71.97,13.78,57.78,33.41-11.3,22.12-62.48-13.78-57.78Z"
			/>
		</svg>
	);
}

const HOW_IT_WORKS_STEPS = [
	{
		title: "ORDER",
		Icon: OrderStepIcon,
		description:
			"Review the designs, explore the live demo, and browse recommended add-on services to find the solution that best fits your business needs. Select your preferred package and hosting option, then place your order.",
	},
	{
		title: "CUSTOMIZE",
		Icon: CustomizeStepIcon,
		description:
			"Once we receive your order, we'll reach out to you to collect the information needed to personalise your site with your branding, logo and business information, based on the package you've chosen.",
	},
	{
		title: "LAUNCH",
		Icon: LaunchStepIcon,
		description:
			"After reviewing your changes and testing your platform, launch with confidence. Start attracting customers and growing your business with a professional, scalable software platform built for long-term success.",
	},
] as const;

export default function ServiceHowItWorksSection() {
	const [introExpanded, setIntroExpanded] = useState(false);
	const [openSteps, setOpenSteps] = useState(() => HOW_IT_WORKS_STEPS.map(() => false));

	const toggleStep = (index: number) => {
		setOpenSteps((current) => {
			const nextOpen = !(current[index] ?? true);
			ga4CtaClick({
				cta_id: nextOpen
					? `how_it_works_step_${index + 1}_expand`
					: `how_it_works_step_${index + 1}_collapse`,
				cta_name: HOW_IT_WORKS_STEPS[index]?.title ?? `Step ${index + 1}`,
				cta_location: "service_how_it_works",
			});
			return current.map((open, i) => (i === index ? !open : open));
		});
	};

	return (
		<section className="mt-8 text-left sm:mt-10" aria-labelledby="service-how-it-works-title">
			<div className="max-w-5xl">
				<h2
					id="service-how-it-works-title"
					className="text-xl font-bold uppercase leading-tight text-core-midnight sm:text-2xl dark:text-white"
				>
					How it works
				</h2>
				<div className="mt-2 h-1 w-12 rounded-full bg-core-primary" aria-hidden />
				<div className="mt-4 space-y-4 text-sm leading-6 text-grey-foreground/90 dark:text-muted-foreground">
					<p>
						At Techxeed, we provide ready-made software solutions that help you launch
						and scale your business faster. Each solution is easy to maintain and
						includes the core technology you need to get started, without the time,
						cost, or complexity of building custom software from scratch
						{introExpanded ? "." : "..."}
						{!introExpanded ? (
							<button
								type="button"
								className="ml-1 text-xs font-semibold text-core-primary underline-offset-2 hover:underline"
								onClick={() => {
									ga4CtaClick({
										cta_id: "how_it_works_read_more",
										cta_name: "Read more",
										cta_location: "service_how_it_works",
									});
									setIntroExpanded(true);
								}}
							>
								Read more
							</button>
						) : null}
					</p>
					{introExpanded ? (
						<p>
							You receive full ownership of your platform under a lifetime licence,
							including the source code, your own hosting environment, and the freedom
							to customise it to suit your brand and business requirements. Unlike
							traditional website builder platforms, you are not locked into
							restrictive systems or limited by what the platform allows you to do.
						</p>
					) : null}
				</div>
			</div>

			<div className="mt-6 grid auto-rows-fr grid-cols-3 items-stretch gap-2 sm:gap-3 md:gap-4 xl:gap-6">
				{HOW_IT_WORKS_STEPS.map((step, index) => {
					const isOpen = openSteps[index] ?? true;
					const descriptionId = `service-how-it-works-step-${index + 1}`;

					return (
						<article
							key={step.title}
							className={`relative flex self-stretch overflow-hidden rounded-lg bg-card shadow-custom transition-transform hover:-translate-y-1 ${
								isOpen ? "h-full flex-col" : "h-14 flex-col sm:h-16"
							}`}
						>
							<button
								type="button"
								className="grid h-14 shrink-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-1 rounded-t-lg bg-muted/40 px-1.5 text-left xs:px-2 sm:h-16 sm:gap-1.5 sm:px-3 lg:gap-2 lg:px-4"
								aria-expanded={isOpen}
								aria-controls={descriptionId}
								onClick={() => toggleStep(index)}
							>
								<span className="inline-flex min-w-0 items-center justify-center gap-0.5 xs:gap-1 sm:gap-1.5 xl:gap-2">
									<step.Icon className="size-[0.9375rem] shrink-0 xs:size-4 sm:size-[1.125rem] md:size-5 lg:size-5 xl:size-6" />
									<h3 className="whitespace-nowrap text-center text-[10.5px] font-bold uppercase leading-tight text-core-midnight xs:text-[11px] sm:text-[13px] md:text-sm lg:text-sm xl:text-lg dark:text-white">
										{step.title}
									</h3>
								</span>
								<ChevronDown
									className={`size-3.5 shrink-0 text-core-primary transition-transform duration-200 sm:size-3.5 md:size-4 xl:size-5 ${
										isOpen ? "rotate-0" : "-rotate-90"
									}`}
									aria-hidden
								/>
							</button>
							<div
								id={descriptionId}
								className={`grid transition-[grid-template-rows] duration-200 ease-out ${
									isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
								}`}
							>
								<div className="min-h-0 overflow-hidden">
									<div className="flex min-h-0 flex-1 flex-col px-2.5 py-3 sm:px-3">
										<span className="flex h-[1.125rem] shrink-0 items-center text-[11px] leading-tight text-brand-primary">
											Step {index + 1}
										</span>
										<p className="mt-2 text-[clamp(0.68rem,2.75vw,0.875rem)] leading-[1.45] text-grey-foreground/90 sm:text-sm sm:leading-6 dark:text-muted-foreground">
											{step.description}
										</p>
									</div>
								</div>
							</div>
						</article>
					);
				})}
			</div>
		</section>
	);
}
